import React, { FC, useEffect } from 'react';
import useStyles from './styles';

import { ReactComponent as JETMapMobile } from '@assets/JETMapMobile-interactive-primary.svg';
import { ReactComponent as JETOrdersTodayMobile } from '@assets/JETOrdersTodayMobile-interactive-primary.svg';
import { ReactComponent as JETActiveCourierMobile } from '@assets/JETActiveCourierMobile-interactive-primary.svg';
import {
  DeliveryMenuNavigationItem,
  useDeliveryNavigationActions,
  useDeliveryNavigationState,
} from '../../context/delivery-navigation';
import { useCouriersActions } from '../../context/couriers';
import { useOrdersActions } from '../../context/orders';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import { isPWA } from '@src/shared/utils';


interface IMobileBottomNavigation {
  navigateTo: DeliveryMenuNavigationItem;
}

export const MobileBottomNavigation: FC<IMobileBottomNavigation> = ({
  navigateTo,
}) => {
  const classes = useStyles();
  const { setActiveMenu  } = useDeliveryNavigationActions();

  const { t } = useTranslation();
  const { selectedNavigationItem } = useDeliveryNavigationState()

  const { setSelectedCourierId } = useCouriersActions();
  const { setSelectedOrderId } = useOrdersActions();
  
  const closePossiblyActiveDetailScreens = () => {
    setSelectedCourierId(null);
    setSelectedOrderId(null);
  }; 

  useEffect(()=> {
    if(selectedNavigationItem !== DeliveryMenuNavigationItem.Map){
      closePossiblyActiveDetailScreens()
    }
  }, [selectedNavigationItem])
  return (
    <>
      {(
        <div className={`${classes.bottomNavigationWrapper} ${isPWA() ? 'isPWA' : ''}`}>
          <div
            className={`${classes.bottomNavigationItems} ${
              navigateTo === DeliveryMenuNavigationItem.CourierApp
                ? 'active'
                : ''
            }`}
            onClick={() => {
              setActiveMenu(DeliveryMenuNavigationItem.CourierApp);
            }}
          >
            <JETActiveCourierMobile style={{height: '22px'}} className="bottomNavigationIconColor" />
            <Typography variant="caption" className="caption">{t('deliveries.tab_couriers')}</Typography>
          </div>
          <div
            className={`${classes.bottomNavigationItems} ${
              navigateTo === DeliveryMenuNavigationItem.Map ? 'active' : ''
            }`}
            onClick={() => {
              setActiveMenu(DeliveryMenuNavigationItem.Map);
            }}
          >
            <JETMapMobile className="bottomNavigationIconColor" />
            <Typography variant="caption" className="caption">Map</Typography>
          </div>
          <div
            className={`${classes.bottomNavigationItems} ${
              navigateTo === DeliveryMenuNavigationItem.Orders ? 'active' : ''
            }`}
            onClick={() => {
              setActiveMenu(DeliveryMenuNavigationItem.Orders);
            }}
          >
            <JETOrdersTodayMobile className="bottomNavigationIconColor" />
            <Typography variant="caption" className="caption">{t('deliveries.tab_orders')}</Typography>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileBottomNavigation;
